import { z } from 'zod';
import { EventListItemDto } from './event';

/**
 * Посещённые события: прошедшие события, на которые юзер был записан (CONFIRMED).
 * `count` — полное число посещений (легаси `events_visited`), `items` — список
 * (ограничен лимитом сервиса), новые сверху.
 */
export const VisitedEventsResponseDto = z.object({
  count: z.number().int(),
  items: z.array(EventListItemDto),
});
export type VisitedEventsResponseDto = z.infer<typeof VisitedEventsResponseDto>;
